import React from 'react';
var css = {
  "title": "oalp-1Faoa"
};
import Heading from "../Heading/Heading";
export var TitleComponent = function TitleComponent(_ref) {
  var className = _ref.className,
    _ref$title = _ref.title,
    style = _ref$title.style,
    text = _ref$title.text,
    heading = _ref$title.heading;
  return heading ? /*#__PURE__*/React.createElement(Heading, {
    type: heading,
    className: className !== null && className !== void 0 ? className : css.title,
    style: style
  }, text) : /*#__PURE__*/React.createElement("div", {
    style: style,
    className: className !== null && className !== void 0 ? className : css.title
  }, text);
};
export default TitleComponent;